<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<div class="card rounded-2">
	<div class="card-body bg-gray-200  px-4 py-2">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#invoice_pane_2">Invoice List</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="invoice_pane_2" role="tabpanel">
				<app-invoice-list></app-invoice-list>
			</div>
		</div>
	</div>
</div>

<app-export-modal></app-export-modal>